import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { SetUserPasswordUsingPinDto } from 'src/api/userService/dto/SetUserPasswordUsingPin.dto';
import { SetUserPasswordUsingPin } from 'src/api/userService/requests';

export const useSetPasswordUsingPin = () =>
    useMutation<boolean, AxiosError, SetUserPasswordUsingPinDto>({
        mutationFn: (data) => SetUserPasswordUsingPin(data),
    });
